import BaseComponentController from "../base_component_controller"
import Pickr from '@simonwep/pickr';

export default class extends BaseComponentController {
  static values = {
    translations: { type: Object, default: {} },
    options: { type: Object, default: {} }
  }

  connect() {
    this.pickr = Pickr.create({ ...this.defaultOptions, ...this.optionsValue });

    this.pickr.on('save', (color, instance) => {
      this.element.value = color ? color.toHEXA() : ''
      this.pickr.hide()
    })
  }

  focus(){
    this.pickr.show()
  }

  get defaultOptions() {
    return {
      el: '.color-picker',
      position: 'bottom-middle',
      theme: 'classic', // 'classic', 'monolith', or 'nano'
      swatches: [
          'rgba(244, 67, 54, 1)',
          'rgba(233, 30, 99, 0.95)',
          'rgba(156, 39, 176, 0.9)',
          'rgba(103, 58, 183, 0.85)',
          'rgba(63, 81, 181, 0.8)',
          'rgba(33, 150, 243, 0.75)',
          'rgba(3, 169, 244, 0.7)',
          'rgba(0, 188, 212, 0.7)',
          'rgba(0, 150, 136, 0.75)',
          'rgba(76, 175, 80, 0.8)',
          'rgba(139, 195, 74, 0.85)',
          'rgba(205, 220, 57, 0.9)',
          'rgba(255, 235, 59, 0.95)',
          'rgba(255, 193, 7, 1)'
      ],
      components: {
        preview: true,
        opacity: true,
        hue: true,
        interaction: {
          input: true,
          clear: true,
          save: true
        }
      },

      i18n: {
        'aria:btn:cancel': this.translationsValue.ariaBtnCancel,
        'aria:btn:clear': this.translationsValue.ariaBtnClear,
        'aria:btn:save': this.translationsValue.ariaBtnSave,
        'aria:hue': this.translationsValue.ariaHue,
        'aria:input': this.translationsValue.ariaInput,
        'aria:opacity': this.translationsValue.ariaOpacity,
        'aria:palette': this.translationsValue.ariaPalette,
        'btn:cancel': this.translationsValue.btnCancel,
        'btn:clear': this.translationsValue.btnClear,
        'btn:last-color': this.translationsValue.btnLastColor,
        'btn:save': this.translationsValue.btnSave,
        'btn:swatch': this.translationsValue.btnSwatch,
        'btn:toggle': this.translationsValue.btnToggle,
        'ui:dialog': this.translationsValue.uiDialog
      }
    }
  }
}
